import React, {useState, useEffect} from 'react'
import './FreeTrial.css';
import logo from '../../assets/Images/logo rev.png';
import { FaPlus, FaMinus } from "react-icons/fa";
import { BiRightArrowAlt } from "react-icons/bi";
import { BiSolidQuoteAltLeft } from "react-icons/bi";
import curve from '../../assets/Images/Rectangle 3772.png';
import { BiSolidQuoteAltRight } from "react-icons/bi";
import maskphoto2 from '../../assets/Images/Mask group.png';
import axios from 'axios';
import Swal from 'sweetalert2';
import { IoIosClose } from "react-icons/io";
import { RiArrowDropDownLine } from "react-icons/ri";
import {  Switch } from '@mui/material';
import { styled } from '@mui/material/styles';
import { IoIosArrowUp } from "react-icons/io";
import { useNavigate } from 'react-router-dom';
import { FaRegCheckCircle } from "react-icons/fa";
import { useRef } from "react";

function FreeTrial() {


    const baseURL =
    process.env.NODE_ENV === "production"
      ? process.env.REACT_APP_API_URL_PROD
      : process.env.REACT_APP_API_URL_LOCAL;

    const navigate = useNavigate("")
    const [openIndex, setOpenIndex] = useState(null);
     const [email, setEmail] = useState('');
    const [showOTP, setShowOTP] = useState(false);
  const [timer, setTimer] = useState(60);
   const [otp, setOtp] = useState(["", "", "", ""]);
   const [isSending, setIsSending] = useState(false);
  const [otpVerified, setOtpVerified] = useState(false);
  const [showpopup, setShowPopup] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [isOpen2, setIsOpen2] = useState(false);
   const [passwordTouched, setPasswordTouched] = useState(false);
    const [submitAttempted, setSubmitAttempted] = useState(false);
    const [emailFormatShown, setEmailFormatShown] = useState(false);
     const [isRegister, setIsRegister] = useState(false);
      const [nameError, setNameError] = useState("");
      const [emailError, setEmailError] = useState("");
      const inputRefs = useRef([]);
       const [passwordErrors, setPasswordErrors] = useState([]);
    
    const [register, setRegister] = useState({
        name: "",
        email: "",
        password: "",
      });

      const [showBanner, setShowBanner] = useState(false);
const [nonNecessaryEnabled, setNonNecessaryEnabled] = useState(true); // default true

useEffect(() => {
  const consent = localStorage.getItem("cookieConsent");
  if (!consent) {
    setShowBanner(true); // show banner for first-time users
  } else {
    const parsedConsent = JSON.parse(consent);
    setNonNecessaryEnabled(parsedConsent.nonNecessaryEnabled);
    if (!parsedConsent.nonNecessaryEnabled) {
      setShowBanner(true); // show banner if user disabled cookies
    } else {
      setShowBanner(false);
    }
  }
}, []);

const handleAccept = () => {
  localStorage.setItem(
    "cookieConsent",
    JSON.stringify({ nonNecessaryEnabled: true })
  );
  setNonNecessaryEnabled(true);
  setShowBanner(false);
};

const handleSaveExit = () => {
  localStorage.setItem(
    "cookieConsent",
    JSON.stringify({ nonNecessaryEnabled })
  );

  if (nonNecessaryEnabled) {
    setShowBanner(false); // hide if enabled
  } else {
    setShowBanner(true); // show if disabled
  }
  setShowPopup(false);
};


      const validatePassword = (password) => {
    const validationErrors = [];
    if (password.length < 8) {
      validationErrors.push("Password must be at least 8 characters long.");
    }
    if (!/[A-Z]/.test(password)) {
      validationErrors.push(
        "Password must contain at least one uppercase letter [A-Z]."
      );
    }
    if (!/[a-z]/.test(password)) {
      validationErrors.push(
        "Password must contain at least one lowercase letter [a-z]."
      );
    }
    if (!/[0-9]/.test(password)) {
      validationErrors.push("Password must contain at least one number [0-9].");
    }
    if (!/[!@#$%^&*(),.?":{}|<>]/.test(password)) {
      validationErrors.push(
        'Password must contain at least one special character[!@#$%^&*(),.?":{}|<>].'
      );
    }
    return validationErrors;
  };

 const onRegisterChange = (e) => {
    const { name, value } = e.target;

    const alphabetRegex = /^[A-Za-z\s]*$/;

    if (name === "name") {
      if (!alphabetRegex.test(value)) {
        setNameError("Enter only alphabets");
      } else {
        setNameError("");
      }
    }

    if (name === "email") {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[cC][oO][mM]$/;

      if (!emailRegex.test(value)) {
        setEmailFormatShown(true);
      } else {
        setEmailFormatShown(false);
      }

      if (submitAttempted) {
        if (value === "") {
          setEmailError("Email is required.");
        } else if (!emailRegex.test(value)) {
          setEmailError("Enter a valid email.");
        } else {
          setEmailError("");
        }
      }
    }

    setRegister({
      ...register,
      [name]: value,
    });
    if (name === "password") {
      setPasswordTouched(true);

      const errors = validatePassword(value);
      setPasswordErrors(errors);
    }
  };

 
  
   const handleSubmit = async (e) => {
      e.preventDefault();
      if (!otpVerified) {
      alert("Please verify OTP first");
      return;
    }
      setSubmitAttempted(true);
      setPasswordTouched(true);
  
      let isValid = true;
  
      
      if (!register.name.trim()) {
        setNameError("Name is required.");
        isValid = false;
      } else if (!/^[A-Za-z\s]+$/.test(register.name.trim())) {
        setNameError("Enter only alphabets.");
        isValid = false;
      } else {
        setNameError("");
      }
  
      const emailRegex = /^[^\s@]+@[^\s@]+\.[cC][oO][mM]$/;
      if (!register.email.trim()) {
        setEmailError("Email is required.");
        isValid = false;
      } else if (!emailRegex.test(register.email.trim())) {
        setEmailError("Enter a valid email.");
        isValid = false;
      } else {
        setEmailError("");
      }
  
     
      const passwordValidation = validatePassword(register.password);
      if (register.password.trim() === "") {
        setPasswordErrors(["Password is required."]);
        isValid = false;
      } else if (passwordValidation.length > 0) {
        setPasswordErrors(passwordValidation);
        isValid = false;
      } else {
        setPasswordErrors([]);
      }
  
      // Stop if any validation fails
      if (!isValid) return;
  
      // Proceed with form submission
      try {
        await axios.post(`${baseURL}/api/register`, register);
        Swal.fire({
          icon: "success",
          title: "Registration Successful!",
          text: "You have been registered successfully.",
          confirmButtonColor: "#FCB124",
          confirmButtonText: "OK",
        });
        navigate('/login')
        setRegister({ name: "", email: "", password: "" });
        setNameError("");
        setEmailError("");
        setPasswordErrors([]);
        setSubmitAttempted(false);
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Submission Failed",
          text: "Error in submitting form or user already registered.",
          confirmButtonColor: "#FCB124",
          confirmButtonText: "OK",
        });
      }
    };
  
    const handleSendOTP = async () => {
    setIsSending(true);
    try {
      const res = await fetch(`${baseURL}/api/freetrial-send-otp`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: register.email }),
      });

      if (res.ok) {
        setShowOTP(true);
        setTimer(120);
        startTimer();
      }
    } catch (err) {
      console.error(err);
    } finally {
      setIsSending(false);
    }
  };

  const startTimer = () => {
    const interval = setInterval(() => {
      setTimer((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  };

 const handleOtpChange = async (value, index) => {
  if (!/^[0-9]?$/.test(value)) return; 

  const newOtp = [...otp];
  newOtp[index] = value;
  setOtp(newOtp);
  if (value && index < otp.length - 1) {
    inputRefs.current[index + 1].focus();
  }
  if (newOtp.join("").length === otp.length && newOtp.every((d) => d !== "")) {
    try {
      const res = await fetch(`${baseURL}/api/freetrial-verify-otp`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          email: register.email,
          otp: newOtp.join(""),
        }),
      });

      const data = await res.json();
      if (data.success) {
        setOtpVerified(true);
      } else {
        setOtpVerified(false);
        alert(data.error);
        setOtp(Array(otp.length).fill(""));
        inputRefs.current[0]?.focus();
      }
    } catch (err) {
      console.error(err);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong. Please try again!",
      });
    }
  }
};


const handleBackspace = (e, index) => {
  if (e.key === "Backspace" && !otp[index] && index > 0) {
    inputRefs.current[index - 1].focus();
  }
};

const handlePaste = async (e) => {
  e.preventDefault();
  const pasteData = e.clipboardData.getData("text").slice(0, otp.length);
  if (!/^\d+$/.test(pasteData)) return;

  const newOtp = [...otp];
  pasteData.split("").forEach((char, i) => {
    newOtp[i] = char;
    if (inputRefs.current[i]) {
      inputRefs.current[i].value = char;
    }
  });
  setOtp(newOtp);

  const lastIndex = pasteData.length - 1;
  if (inputRefs.current[lastIndex]) {
    inputRefs.current[lastIndex].focus();
  }

  if (newOtp.join("").length === otp.length && newOtp.every((d) => d !== "")) {
    try {
      const res = await fetch(`${baseURL}/api/freetrial-verify-otp`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          email: register.email,
          otp: newOtp.join(""),
        }),
      });

      const data = await res.json();
      if (data.success) {
        setOtpVerified(true);
      } else {
        setOtpVerified(false);
        alert(data.error);
        setOtp(Array(otp.length).fill(""));
        inputRefs.current[0]?.focus();
      }
    } catch (err) {
      console.error(err);
    }
  }
};


  const content = `This website uses cookies to improve your experience while
   you navigate through the website. Out of these cookies, the cookies that are categorized as necessary 
   are stored on your browser as they are as essential for the working of basic functionalities of the 
   website. We also use third-party cookies that help us analyze and understand how you use this website.
    These cookies will be stored in your browser only with your consent. You also have the option to
     opt-out of these cookies. But opting out of some of these cookies may have an effect on your browsing
      experience.`;

  const toggleReadMore = () => {
    setIsExpanded(!isExpanded);
  };

  const toggleContent = () => {
    setIsOpen2(false);
    setIsOpen(!isOpen);
    
  }

  const toggleContent2 = () => {
    setIsOpen(false)
    setIsOpen2(!isOpen2)
    
  }

  const handleClose = () => {
    setShowPopup(false);
  }

const CustomSwitch = styled((props) => <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />)(
  ({ theme }) => ({
    width: 60,
    height: 25,
    padding: 0,
    display: 'flex',
    marginLeft:10,
    '& .MuiSwitch-switchBase': {
      padding: 4,
      '&.Mui-checked': {
        transform: 'translateX(26px)',
        color: '#009F0B',
        '& + .MuiSwitch-track': {
          backgroundColor: '#009F0B',
          '&:before': {
            left: 8,
          },
        },
      },
    },
    '& .MuiSwitch-thumb': {
      boxShadow: '0 2px 4px 0 rgb(0 0 0 / 20%)',
      width: 19,
      height: 19,
      borderRadius: '50%',
      backgroundColor: '#D9D9D9',
      marginLeft:5,
    },
    '& .MuiSwitch-track': {
      position: 'relative',
      borderRadius: 34 / 2,
      backgroundColor: 'grey',
      transition: theme.transitions.create(['background-color'], {
        duration: 500,
      }),
      '&:before': {
        position: 'absolute',
        top: '50%',
        transform: 'translateY(-50%)',
        left: 34,
        color: 'white',
        fontSize: 12,
        fontWeight: 600,
      },
    },
  })
);
  
 
 

  useEffect(() => {
    let interval;
    if (showOTP && timer > 0) {
      interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [showOTP, timer]);

  const handleSendOTPpopup = () => {
    setShowOTP(true);
    setTimer(60); 
  };

  const cookiePopup = () => {
    setShowPopup(true);
  }

     const handlePricingClick = async () => {
              if (!email) {
                alert("Please enter a valid email address");
                return;
              }
          
              try {
                await axios.post(`${baseURL}/api/send-mail`, { email });
                Swal.fire({
                icon: "success",
                title: "Success",
                text: "Email sent successfully!",
              });
              } catch (error) {
                console.error("Error sending email:", error);
                Swal.fire({
                icon: "error",
                title: "Oops!",
                text: "Failed to send email. Please try again later.",
              });
              }
            };

    const faqs = [
  {
    question: "Is the RevenueIntel trial really free ?",
    answer:
      "Yes. The trial provides complimentary credits to explore RevenueIntel's DemandGen Intelligence Platform with no hidden charges. You can test core features and evaluate how they fit into your Demandgen workflow at zero cost.",
  },
  {
    question: "Do I need a credit card to start the free trial ?",
    answer:
      "No. Getting started is simple—just complete the signup form and verify your business email. No credit card is required.",
  },
   {
    question: "What features are included in the trial ?",
    answer: [
      {
        type: "text",
        content:
          "You’ll have access to our key features & capabilities, with usage limits based on your trial credits. These typically include:",
      },
       {
        type: "list",
        content: [
          "Verified contact and company search",
          "ICP and account matching",
          "Scoop & sales intelligence insights",
          "Email outreach tools and personalization",
          "CRM sync and pipeline support",
        ],
      },
    ],
  },
{
    question: "How long does the RevenueIntel free trial last ?",
    answer: [
      {
        type: "text",
        content:
          "Most free trials include100 credits valid for 30 days. During this period, you can test the platform’s data intelligence, engagement tools, and pipeline features. Trial duration and credits may vary depending on:",
      },
      {
        type: "list",
        content: [
          "Current promotional offers",
          "Your company size or industry focus",
          "The product package you select",
          "Whether you’re working directly with our sales team",
        ],
      },
    ],
  },
  {
    question: "Can I cancel the trial at any time?",
    answer:
      "Yes. The trial automatically expires at the end of your credit period. You’re under no obligation to continue, but you’ll have the option to upgrade seamlessly to a paid plan.",
  },
  {
    question: "Can I speak to a RevenueIntel expert during the trial ?",
    answer:
      "Absolutely. Our product specialists are available to walk you through the platform, answer questions, and help align features to your demand generation goals.",
  },
  {
    question: "What happens when my trial credits run out ?",
    answer:
      "Once credits are used up, access to the platform pauses. You can choose to upgrade to a paid subscription to continue without losing your saved work, leads, or settings.",
  },
  {
    question: "Can multiple team members use the same trial account ?",
    answer:
      "The free trial is designed for single-user access. For multi-user trials, please contact our sales team.",
  },
  {
    question: "Will my trial data carry over if I upgrade ?",
    answer:
      "Yes. Any saved searches, contacts, or campaign settings from your trial account will remain available when you upgrade to a paid subscription.",
  },
  {
    question: "Is the data in the trial the same as in the paid version ?",
    answer:
      "Yes, you’ll experience the same verified data quality and AI-driven insights as paid users, the only difference is the usage limits applied during the trial.",
  },
];


  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <>
    
     <div className="free-trial-section">
  <div className="overlay-content">
    <img src={logo} onClick={() => navigate("/")} alt="logo" className="trial-logo" />
<div> <div className="trial-heading">Start Your Free Trial Now</div> 
 <div className='trial-sub-head'>No credit card required — get started in minutes.</div></div>
   
    {/* <div className='trial-sub-head'>No credit card required — get started in minutes.</div> */}
    <div className="trial-form">
  <div className="free-trial-text">Free Trial</div>
  <form className="trial-form-fields" onSubmit={handleSubmit}>
    <div className="form-group">
      <label>Name <span>*</span></label>
       <input type="text" name="name" value={register.name} onChange={onRegisterChange} required />
        {nameError && (submitAttempted || register.name) && (
                    <p
                      style={{ color: "Red", fontSize: "12px", marginLeft:"50px" }}
                      className="error-text"
                    >
                      {nameError}
                    </p>
                  )}
    </div>

    <div className="form-group email-group">
      <label>Email <span>*</span></label>
      <div className="email-input">
        <input type="email" name="email" value={register.email} onChange={onRegisterChange} required />
   {!otpVerified ? (
    isSending ? (
      <span className="loader"></span> 
    ) : (
      <button
        type="button"
        className="send-otp"
        onClick={handleSendOTP}
      >
        Send OTP
      </button>
    )
  ) : (
    <span className="tick"><FaRegCheckCircle /></span> 
  )}
         
      </div>
       {emailFormatShown && !submitAttempted && (
                    <p style={{ color: "gray", fontSize: "12px", marginLeft:"50px" }}>
                      Email format must be in : example@domain.com
                    </p>
                  )}

                  {submitAttempted && emailError && (
                    <p style={{ color: "red", fontSize: "12px" }}>
                      {emailError}
                    </p>
                  )}
    </div>
    {showOTP && !otpVerified && (
  <div className="form-group otp-group">
    <label>OTP</label>
    <div className="otp-inputs">
      {otp.map((digit, i) => (
        <input
          key={i}
          type="text"
          maxLength="1"
          value={digit}
          onChange={(e) => handleOtpChange(e.target.value, i)}
          onKeyDown={(e) => handleBackspace(e, i)}
          onPaste={(e) => handlePaste(e)}
          ref={(el) => (inputRefs.current[i] = el)} // keep refs
        />
      ))}
      <span className="otp-timer">
        (Expires in{" "}
        <span style={{ color: "red" }}>
          00:{timer < 10 ? `0${timer}` : timer}
        </span>
        )
      </span>
    </div>
  </div>
)}

    <div className="form-group">
      <label>Password <span>*</span></label>
       <input type="password" name="password" value={register.password} onChange={onRegisterChange} required />
        {passwordTouched && passwordErrors.length > 0 && (
                    <ul className="error-list" style={{marginLeft:"20px"}}>
                      {passwordErrors.map((error, index) => (
                        <li
                          key={index}
                          className={`error-item ${
                            submitAttempted ? "highlight" : ""
                          }`}
                        >
                          {error}
                        </li>
                      ))}
                    </ul>
                  )}
    </div>

    <div className="checkbox-group">
       <input type="checkbox" id="terms" required />
      <label htmlFor="terms">
        By submitting this form, you agree to our <b>Terms of Use</b>, <b>Privacy Policy</b>, 
        and consent to receiving marketing communications from us.
      </label>
    </div>

    <button type="submit" className="register-btn">Register</button>
  </form>
</div>

  </div>
</div>

<div className="faq-wrapper">
      <div className="faq-left">FAQs</div>
      <div className="faq-right">
      {faqs.map((faq, index) => (
  <div key={index} className="faq-item">
    <div className="faq-question" onClick={() => toggleFAQ(index)}>
      <span>{faq.question}</span>
      <span className="faq-icon">
        {openIndex === index ? (
          <IoIosArrowUp style={{ fontSize: "25px" }} />
        ) : (
          <RiArrowDropDownLine style={{ fontSize: "35px" }} />
        )}
      </span>
    </div>
    {openIndex === index && (
      <div className="faq-answer">
        {Array.isArray(faq.answer) ? (
          faq.answer.map((item, i) =>
            item.type === "text" ? (
              <p key={i}>{item.content}</p>
            ) : (
              <ul key={i}>
                {item.content.map((listItem, j) => (
                  <li key={j}>{listItem}</li>
                ))}
              </ul>
            )
          )
        ) : (
          <p>{faq.answer}</p>
        )}
      </div>
    )}
  </div>
))}

      </div>
    </div>

     <div className='lead-generating-trial'>
                   <span className="lead-text-trial">Start generating B2B leads today!</span>
                    <button className='demo-btn-talk'>Talk to us  <span className="btn-icon"><BiRightArrowAlt /> </span></button>
                  </div>

                   <div className='landing-6'>
                                      <BiSolidQuoteAltLeft style={{marginLeft:"21%",marginTop:"40px"}} />
                                     <div className='content-9'>
                                   Accurate key Insights provided on a timely basis. This really helps for our 
                                     <br /> Sales process to get started &nbsp; <BiSolidQuoteAltRight style={{fontSize:"15px"}}/>  </div> 
                                    
                                      <div style={{marginLeft:"100px", marginTop:"10px", color:"black", fontWeight:"700", textAlign:"center", fontSize:"12px"}} >
                                       <img src={maskphoto2} alt="maskphoto"  width="50px"/> <br />Erhan Eren <div style={{fontWeight:"500"}}>Founder and CEO, Enkiai.com</div></div>  
                                    
                       
                                     </div>
                                 <div className="curved-footer-wrapper">
                         <div className="footer-image-container">
                           <img src={curve} alt="curve" className="footer-curve-img" style={{height:"300px"}}/>
                           <div className="landing-7">
                             <div className="land-contents-10" style={{color:"#FFFFFF"}}>
                               We’d love to hear from you <br />
                               <span className="land-content-11" style={{marginTop:"20px"}}>support@revenuintel.com</span><br />
                              
                             </div>
                             <div className="land-contents-11" style={{color:"#FFFFFF"}}>
                               Get Revenuintel Today <br />
                               <div style={{ position: "relative", display: "flex", alignItems: "center", marginTop: "40px" }}>
                         <input type="email" placeholder='Business mail' className='mail-input-trial' value={email}
                          onChange={(e) => setEmail(e.target.value)} />
                         <button className="mail-price-btn-trial" onClick={handlePricingClick}>Pricing</button>
                       </div>
                       
                               
                             </div>
                             <div className="land-contents-13" style={{fontWeight:"500", color:"#FFFFFF"}}>
                               Powered by, <br />
                               Merkat Intellekt Technologies <br />
                               <span className="land-content-15">Private Limited</span>
                             </div>
                           </div>
                         </div>
                       </div>
                       {showBanner && (
                       <div className='cookies'>
                          <div className='cookie-text'>This website uses cookies to improve your experience. We'll assume you're ok with this, but you can opt-out if you wish</div>
                       <div className='cookie' style={{cursor:"pointer"}} onClick={cookiePopup}>Cookie Settings</div>
                       <div> <button className="cookie-btn" onClick={handleAccept}>Accept</button></div>
                       </div> )}
                 {showpopup && (
  <div className="overlay">
    <div className="privacy-popup">
      <div className="privacy-overview">
        <div className="popup-header">Privacy Overview</div>
        <div className='privacy-close' onClick={handleClose}><IoIosClose /></div>
      </div>
     <div className="privacy-content">
      {isExpanded ? content : `${content.substring(0, 200)}...`}
      <span
        className="privacy-content-span"
        onClick={toggleReadMore}
        style={{ color: "blue", cursor: "pointer", marginLeft: "5px" }}
      >
        {isExpanded ? " See Less" : " See More"}
      </span>
    </div>
   <div className="privacy-neccessary">
      <div className="neccessary-head" >
        <div className="neccessary-text" onClick={toggleContent}>
          <RiArrowDropDownLine
            style={{
              fontSize: "35px",
              transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
              transition: "transform 0.3s ease"
            }}
          />{" "}
          Necessary
        </div>
        <div className="neccessary-text">Always Enabled</div>
      </div>

      {isOpen && (
        <div className="neccessary-content">
          Necessary cookies are absolutely essential for the website to
          function properly. This category only includes cookies that ensure
          basic functionalities and security features of the website. These
          cookies do not store any personal information.
        </div>
      )}
    </div>
     <div className="privacy-neccessary">
      <div className="neccessary-head" >
        <div className="neccessary-text" onClick={toggleContent2}>
          <RiArrowDropDownLine
            style={{
              fontSize: "35px",
              transform: isOpen2 ? "rotate(180deg)" : "rotate(0deg)",
              transition: "transform 0.3s ease"
            }}
          />{" "}
         Non-Necessary
        </div>
        <div> <CustomSwitch checked={nonNecessaryEnabled}
              onChange={(e) => setNonNecessaryEnabled(e.target.checked)} /></div>
      </div>

      {isOpen2 && (
        <div className="neccessary-content">
         Any cookies that may not be particularly necessary for the website to function
          and is used specifically to collect user personal data via analytics, ads, other embedded 
          contents are termed as non-necessary cookies. It is mandatory to procure user consent prior
           to running these cookies on your website.
        </div>
      )}
    </div>
    <div className='privacy-save'>
      <button className='privacy-save-btn' onClick={handleSaveExit}>Save & Exit</button>
    </div>
    </div>
  </div>
)}

</>
  )
}

export default FreeTrial
